// extracted by mini-css-extract-plugin
export default {"billingStatusIcon":"billing-status-display_billingStatusIcon__XJ0Vu"};